import _toConsumableArray from "@babel/runtime/helpers/toConsumableArray";
import _defineProperty from "@babel/runtime/helpers/defineProperty";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(source, true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(source).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

import BlockTypes from '../../types/BlockTypes';
import StyleTypes from '../../types/StyleTypes';
import EntityTypes from '../../types/EntityTypes';
import CommandTypes from '../../types/CommandTypes';
export var BASIC_SELECTION = 1;
export var EXPANDED_SELECTION = 2;
export var BASIC_INSERTION = 4;
export var EXPANDED_INSERTION = 8;
export var TOOLBAR_BUTTON_VISIBILITY = {
  BASIC_SELECTION: BASIC_SELECTION,
  EXPANDED_SELECTION: EXPANDED_SELECTION,
  BASIC_INSERTION: BASIC_INSERTION,
  EXPANDED_INSERTION: EXPANDED_INSERTION
};
export var TOOLBAR_ORDER = [StyleTypes.BOLD, StyleTypes.ITALIC, BlockTypes.H1, BlockTypes.H2, BlockTypes.H3, StyleTypes.STRIKETHROUGH, StyleTypes.UNDERLINE, EntityTypes.PLACEHOLDER, BlockTypes.TODO, BlockTypes.OL_LI, BlockTypes.UL_LI, BlockTypes.FILE, BlockTypes.IMAGE, BlockTypes.TABLE_CELL, BlockTypes.DATABASE, BlockTypes.SEPARATOR, BlockTypes.QUOTE, BlockTypes.HINT, BlockTypes.CODE, StyleTypes.CODE, EntityTypes.MENTION, EntityTypes.NOTELINK, EntityTypes.LINK, StyleTypes.HIGHLIGHT, EntityTypes.COMMENT, EntityTypes.EMOJI, CommandTypes.TODAY, BlockTypes.EMBED, BlockTypes.INTEGRATION_TILE, CommandTypes.LOREM_IPSUM, undefined];
export default function makeToolbarButton(id, buttonOptions) {
  return {
    toolbarButton: function toolbarButton() {
      var options = buttonOptions;

      if (buttonOptions instanceof Function) {
        options = buttonOptions();
      }

      var index = options.index || TOOLBAR_ORDER.indexOf(id);
      var _options = options,
          _options$title = _options.title,
          title = _options$title === void 0 ? '' : _options$title,
          _options$alias = _options.alias,
          alias = _options$alias === void 0 ? [] : _options$alias;
      return _objectSpread({
        id: id
      }, options, {
        index: index,
        searchTerms: [].concat(_toConsumableArray(alias), [title.toLowerCase()])
      });
    }
  };
}